import { render, staticRenderFns } from "./input-color-preview.vue?vue&type=template&id=ebb6a40a&scoped=true"
import script from "./input-color-preview.vue?vue&type=script&lang=js"
export * from "./input-color-preview.vue?vue&type=script&lang=js"
import style0 from "./input-color-preview.vue?vue&type=style&index=0&id=ebb6a40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb6a40a",
  null
  
)

export default component.exports